export const CONFIGURATIONS = {
        TEMG:'tEMG',
        MUSCLETO4:'Muscle TO4',
        OTHER_MODALITY:'Other Modality',
        SEDATIVE_BOLUS:'Sedative-bolus',
        NARCOTICS:'Narcotics',
}
